var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 680,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 680,
    fill: "#94886d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "256,185 255,-16 161,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffea",
    fillOpacity: 0.501961,
    points: "120,124 121,-16 -16,24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffed",
    fillOpacity: 0.501961,
    points: "-16,160 86,105 90,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1b1900",
    fillOpacity: 0.501961,
    points: "78,107 -16,132 12,62"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#030000",
    fillOpacity: 0.501961,
    points: "271,6 199,62 178,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffbe1",
    fillOpacity: 0.501961,
    points: "157,-16 190,8 165,126"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#060502",
    fillOpacity: 0.501961,
    points: "251,185 271,106 180,164"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5a1600",
    fillOpacity: 0.501961,
    points: "147,3 163,41 106,89"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecd7d6",
    fillOpacity: 0.501961,
    points: "119,91 199,156 133,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffb8",
    fillOpacity: 0.501961,
    points: "-16,134 81,185 81,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#300000",
    fillOpacity: 0.501961,
    points: "126,159 102,150 137,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8f5cd",
    fillOpacity: 0.501961,
    points: "65,69 160,-11 -16,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff6",
    fillOpacity: 0.501961,
    points: "213,59 233,57 233,75"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#311000",
    fillOpacity: 0.501961,
    points: "164,41 139,5 147,78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "133,4 170,18 160,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "19,24 0,-16 0,48"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bc7744",
    fillOpacity: 0.501961,
    points: "70,108 145,27 110,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "181,126 179,104 202,129"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffbd3",
    fillOpacity: 0.501961,
    points: "158,121 182,178 184,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d0300",
    fillOpacity: 0.501961,
    points: "21,31 38,2 24,13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "71,88 84,100 77,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#786b32",
    fillOpacity: 0.501961,
    points: "-16,85 54,100 96,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff0",
    fillOpacity: 0.501961,
    points: "109,157 117,185 81,164"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#551400",
    fillOpacity: 0.501961,
    points: "109,118 91,162 95,113"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#262113",
    fillOpacity: 0.501961,
    points: "271,-12 178,9 241,67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8e3c3",
    fillOpacity: 0.501961,
    points: "117,133 87,86 139,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#350000",
    fillOpacity: 0.501961,
    points: "140,112 120,126 122,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7e1bc",
    fillOpacity: 0.501961,
    points: "113,68 39,77 40,-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#74694c",
    fillOpacity: 0.501961,
    points: "189,110 235,73 156,58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcf2b0",
    fillOpacity: 0.501961,
    points: "104,146 -10,176 32,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eee2dc",
    fillOpacity: 0.501961,
    points: "115,105 177,78 111,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2f2c20",
    fillOpacity: 0.501961,
    points: "197,168 250,178 266,-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8f8d9",
    fillOpacity: 0.501961,
    points: "149,-12 190,43 171,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a3964f",
    fillOpacity: 0.501961,
    points: "28,39 -16,83 54,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffa",
    fillOpacity: 0.501961,
    points: "133,-10 109,55 96,30"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5c5335",
    fillOpacity: 0.501961,
    points: "206,-16 229,101 182,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#531e00",
    fillOpacity: 0.501961,
    points: "99,147 79,157 98,162"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1f1605",
    fillOpacity: 0.501961,
    points: "126,4 159,45 160,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b77545",
    fillOpacity: 0.501961,
    points: "118,44 156,88 132,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#342f13",
    fillOpacity: 0.501961,
    points: "13,92 -16,124 78,112"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#551000",
    fillOpacity: 0.501961,
    points: "105,104 100,92 117,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#615051",
    fillOpacity: 0.501961,
    points: "167,141 80,185 170,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a8582",
    fillOpacity: 0.501961,
    points: "116,167 157,78 161,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c66a33",
    fillOpacity: 0.501961,
    points: "86,87 100,117 84,137"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1f0000",
    fillOpacity: 0.501961,
    points: "122,155 123,133 104,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe19e",
    fillOpacity: 0.501961,
    points: "105,135 97,146 107,163"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b261f",
    fillOpacity: 0.501961,
    points: "250,175 184,148 182,179"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7e7a53",
    fillOpacity: 0.501961,
    points: "111,-3 94,-16 103,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c19da5",
    fillOpacity: 0.501961,
    points: "146,127 200,155 207,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c7b8b4",
    fillOpacity: 0.501961,
    points: "169,137 175,80 153,65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bebc5b",
    fillOpacity: 0.501961,
    points: "26,141 -4,173 -16,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "106,64 71,87 99,78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4a0e00",
    fillOpacity: 0.501961,
    points: "120,120 142,126 126,102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "95,133 107,115 106,131"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#713a06",
    fillOpacity: 0.501961,
    points: "148,70 167,62 143,35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "35,10 51,30 42,-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#421400",
    fillOpacity: 0.501961,
    points: "88,90 88,107 82,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bdb2aa",
    fillOpacity: 0.501961,
    points: "181,109 188,106 188,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe3b6",
    fillOpacity: 0.501961,
    points: "116,117 72,113 122,99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4c4636",
    fillOpacity: 0.501961,
    points: "211,144 203,32 177,62"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fefcd7",
    fillOpacity: 0.501961,
    points: "225,55 215,66 235,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "73,158 74,108 88,151"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5f2600",
    fillOpacity: 0.501961,
    points: "132,58 115,84 124,49"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "39,73 43,79 61,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dbd3ca",
    fillOpacity: 0.501961,
    points: "135,104 143,62 105,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccc898",
    fillOpacity: 0.501961,
    points: "39,-13 26,16 -4,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#330700",
    fillOpacity: 0.501961,
    points: "137,136 108,134 105,153"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#65572f",
    fillOpacity: 0.501961,
    points: "55,69 49,93 81,114"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#888c4d",
    fillOpacity: 0.501961,
    points: "230,93 202,59 216,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#81823f",
    fillOpacity: 0.501961,
    points: "166,26 182,23 171,13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9f6b8",
    fillOpacity: 0.501961,
    points: "184,166 171,143 168,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#221e1a",
    fillOpacity: 0.501961,
    points: "190,113 190,134 174,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff8cd",
    fillOpacity: 0.501961,
    points: "117,118 90,98 93,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a7f53",
    fillOpacity: 0.501961,
    points: "78,48 74,28 81,16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b4ac73",
    fillOpacity: 0.501961,
    points: "36,51 46,28 65,16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#18140c",
    fillOpacity: 0.501961,
    points: "271,-14 174,-16 271,55"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#474236",
    fillOpacity: 0.501961,
    points: "256,105 206,137 235,163"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#655c1f",
    fillOpacity: 0.501961,
    points: "21,22 32,6 39,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#605515",
    fillOpacity: 0.501961,
    points: "78,7 88,-5 82,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "74,110 75,83 82,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8ead8",
    fillOpacity: 0.501961,
    points: "145,-16 188,12 139,7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "161,6 161,25 144,-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5d1ac",
    fillOpacity: 0.501961,
    points: "112,-16 132,10 113,25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcfcea",
    fillOpacity: 0.501961,
    points: "93,24 86,69 77,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff1",
    fillOpacity: 0.501961,
    points: "175,115 178,110 180,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#665f39",
    fillOpacity: 0.501961,
    points: "58,101 -16,94 24,58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a1e12",
    fillOpacity: 0.501961,
    points: "148,8 160,19 131,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebe59e",
    fillOpacity: 0.501961,
    points: "-16,151 105,161 74,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cb7338",
    fillOpacity: 0.501961,
    points: "100,116 89,145 89,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e7b378",
    fillOpacity: 0.501961,
    points: "120,46 126,60 72,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8eebf",
    fillOpacity: 0.501961,
    points: "181,71 163,55 161,19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffb",
    fillOpacity: 0.501961,
    points: "43,46 35,15 29,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#232215",
    fillOpacity: 0.501961,
    points: "178,106 182,132 188,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#592700",
    fillOpacity: 0.501961,
    points: "79,157 100,153 93,147"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdfbdd",
    fillOpacity: 0.501961,
    points: "50,0 66,-5 55,19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f6f7e5",
    fillOpacity: 0.501961,
    points: "64,24 48,71 77,49"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4a4130",
    fillOpacity: 0.501961,
    points: "208,30 170,77 224,67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5d5634",
    fillOpacity: 0.501961,
    points: "50,12 51,3 45,-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dfddda",
    fillOpacity: 0.501961,
    points: "172,124 159,89 158,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b6b077",
    fillOpacity: 0.501961,
    points: "62,51 66,40 81,75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeLow);
export default __webpack_public_path__ + "static/media/welcome_low.9d88d60fb56999988342bf6eb7de5a6b.svg";
export { ForwardRef as ReactComponent };